import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { teamApi } from '@/shared/api';
import { trpc } from '@/config/trpc';

import useNotification from '@/shared/hooks/UseNotification';

type Data = {
  teamId: string;
  teamInvitationId: string;
};

const useAcceptTeamInvitation = () => {
  const { t } = useTranslation();
  const trpcUtils = trpc.useUtils();
  const { sendDefaultError, sendNotification } = useNotification();

  const { isLoading, mutate, mutateAsync } = useMutation({
    mutationFn: (data: Data) => teamApi.acceptTeamInvitation(data),
    onError: sendDefaultError,
    onSuccess: () => {
      trpcUtils.team.currentTeam.invalidate();
      sendNotification({
        header: t('success'),
        message: t('typeSuccessfullyAccepted', { type: t('invitation_one') }),
        variant: 'success',
      });
    },
  });
  return {
    acceptTeamInvitation: mutate,
    acceptTeamInvitationAsync: mutateAsync,
    isAcceptingTeamInvitation: isLoading,
  };
};

export default useAcceptTeamInvitation;
